/* Shared route table for the Deal Management module. Paths are RELATIVE to a
   `/deal-management/*` parent route, so the same table works under the app's
   BrowserRouter (standalone route) and under the embedded MemoryRouter (dashboard
   tab). Screens navigate via BASE ('/deal-management') in helpers.js, so the parent
   segment lines up in both mounts. */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Pipeline from './screens/Pipeline';
import Deal from './screens/Deal';
import Dashboard from './screens/Dashboard';
import Profile from './screens/Profile';
import Sandbox from './screens/Sandbox';

export default function DealRoutes() {
	return (
		<Routes>
			<Route index element={<Pipeline view="board" />} />
			<Route path="pipeline" element={<Pipeline view="board" />} />
			<Route path="pipeline/list" element={<Pipeline view="list" />} />
			<Route path="dashboard" element={<Dashboard />} />
			<Route path="profile" element={<Profile />} />
			<Route path="sandbox" element={<Sandbox />} />
			<Route path="deal/:id/:step" element={<Deal />} />
			<Route path="deal/:id/:step/:tab" element={<Deal />} />
			<Route path="*" element={<Navigate to="pipeline" replace />} />
		</Routes>
	);
}
